// src/hooks/useGoreliZamanTiki.ts
//
// ══════════════════════════════════════════════════════════════════════════
// #888 — BAYAT GÖRELİ ZAMAN: TEK PAYLAŞILAN TİK
// ══════════════════════════════════════════════════════════════════════════
//
// 🩺 KUSUR (sanal dünya C20 sondası, `scripts/virtual-world/saat-sondasi.js`):
//    «göreli zaman 6→6» — 26 saatlik saat sıçramasında bile ekrandaki altı
//    «… önce» metninin HİÇBİRİ değişmedi. Sebep `src/utils.ts formatTimeAgo`in
//    SAF ve TIMERSIZ olması: `Date.now()`u render anında okur, ama hiçbir şey
//    yeniden render tetiklemez. Kullanıcı uygulamayı açık bıraktığında zaman
//    donar; «2 dakika önce» saatlerce «2 dakika önce» kalır.
//
// 🔧 ÇÖZÜM — VE ÇÖZÜMÜN TUZAĞI: naif düzeltme her kartın içine bir
//    `setInterval` koymaktır. 200 kartlık bir akışta bu 200 zamanlayıcı
//    demektir; kusuru bir performans kusuruyla takas etmiş oluruz. Burada
//    UYGULAMA BOYUNCA **TEK** zamanlayıcı vardır: abone sayısı 0'dan 1'e
//    çıkınca kurulur, 1'den 0'a düşünce yok edilir. Kaç bileşen dinlerse
//    dinlesin `setInterval` sayısı 1'i geçmez (`zamanlayiciSayisi()` bunu
//    testte ÖLÇÜLEBİLİR kılar — iddia değil, sayı).
//
// 👁️ GÖRÜNÜRLÜK KAPISI: sekme arkadayken tik ÇALIŞMAZ (görünmeyen ekranı
//    yeniden çizmek boşa iş + pil). Sekmeye/pencereye dönüldüğünde ANINDA bir
//    tik yayınlanır — kullanıcının gördüğü ilk kare zaten tazedir. Saat
//    sıçraması (uyku/uçak modu/saat değişimi) tam olarak bu yoldan yakalanır.
//
// 🔒 SINIR: bu modül ZAMAN BİÇİMLENDİRMEZ. Yalnız "şimdi yeniden çiz" der.
//    Biçimlendirme tek kaynakta (`src/utils.ts formatTimeAgo`) kalır.

import { useSyncExternalStore } from "react";

/** Tik aralığı. Dakika-altı hassasiyet göreli zamanda anlamsız (ve pahalı). */
export const TIK_MS = 60_000;

const aboneler = new Set<() => void>();
let zamanlayici: ReturnType<typeof setInterval> | null = null;
let dinleyicilerKurulu = false;
let surum = 0;

/** 📏 ÖLÇÜM KANCASI: aynı anda kaç zamanlayıcı canlı? (test bunu sayar) */
export const zamanlayiciSayisi = (): number => (zamanlayici === null ? 0 : 1);
/** Test/tanı: kaç bileşen dinliyor. */
export const aboneSayisi = (): number => aboneler.size;

const gorunurMu = (): boolean =>
  typeof document === "undefined" || document.visibilityState !== "hidden";

function yayinla(): void {
  surum += 1;
  // Kopya üzerinde gez: dinleyici kendini abonelikten çıkarabilir.
  Array.prototype.forEach.call(Array.from(aboneler), (f: () => void) => {
    try { f(); } catch { /* bir dinleyicinin hatası diğerlerini düşürmez */ }
  });
}

function zamanlayiciyiKur(): void {
  if (zamanlayici !== null) return;              // ← TEK zamanlayıcı garantisi
  if (typeof setInterval !== "function") return;
  zamanlayici = setInterval(() => {
    // Arka plandaki sekmede yeniden çizim yapma; dönüşte zaten tik atılacak.
    if (gorunurMu()) yayinla();
  }, TIK_MS);
}

function zamanlayiciyiSok(): void {
  if (zamanlayici === null) return;
  clearInterval(zamanlayici);
  zamanlayici = null;
}

function geriDondu(): void {
  // Sekmeye/pencereye dönüş: saat sıçramış olabilir → ANINDA tazele.
  if (gorunurMu()) yayinla();
}

function dinleyicileriKur(): void {
  if (dinleyicilerKurulu) return;
  if (typeof document !== "undefined" && document.addEventListener) {
    document.addEventListener("visibilitychange", geriDondu);
  }
  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("focus", geriDondu);
  }
  dinleyicilerKurulu = true;
}

function dinleyicileriSok(): void {
  if (!dinleyicilerKurulu) return;
  if (typeof document !== "undefined" && document.removeEventListener) {
    document.removeEventListener("visibilitychange", geriDondu);
  }
  if (typeof window !== "undefined" && window.removeEventListener) {
    window.removeEventListener("focus", geriDondu);
  }
  dinleyicilerKurulu = false;
}

/** `useSyncExternalStore` abonelik fonksiyonu. */
function abone(dinleyici: () => void): () => void {
  aboneler.add(dinleyici);
  if (aboneler.size === 1) { zamanlayiciyiKur(); dinleyicileriKur(); }
  return () => {
    aboneler.delete(dinleyici);
    if (aboneler.size === 0) { zamanlayiciyiSok(); dinleyicileriSok(); }
  };
}

const anlikGoruntu = (): number => surum;

/**
 * Göreli zaman metni gösteren bileşenler bunu çağırır. Dönen sayı her tikte
 * artar → bileşen yeniden çizilir → `formatTimeAgo` TAZE `Date.now()` okur.
 *
 * Değeri kullanmak ZORUNLU DEĞİL; çağırmak yeter (yeniden çizim React'in
 * abonelik mekanizmasından gelir). Zamanlayıcı sayısı abone sayısından
 * BAĞIMSIZDIR ve daima ≤ 1'dir.
 */
export function useGoreliZamanTiki(): number {
  return useSyncExternalStore(abone, anlikGoruntu, anlikGoruntu);
}

/** Test yardımcısı: modül durumunu sıfırla (süitler arası sızıntı olmasın). */
export function _testSifirla(): void {
  aboneler.clear();
  zamanlayiciyiSok();
  dinleyicileriSok();
  surum = 0;
}
